export const EntityActionTypes = {
    GET_COMPANY_JOBS: "GET_COMPANY_JOBS",
};
export const getcompanyJobs = (jobData) => {
    return {
        type: EntityActionTypes.GET_COMPANY_JOBS,
        jobData,
    };
};